import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useWorkOrderDetail } from '../../services/business/workOrders';
import NewWorkOrderV4 from './NewWorkOrder/NewWorkOrderV4';

/**
 * Editor shell — mirrors InvoiceEdit. Loads the record when editing and hands it to the
 * editor; renders an empty editor when creating.
 */
const WorkOrderEdit = () => {
    const { id } = useParams();
    const [showLoader, setShowLoader] = useState(false);

    const { data: workOrderData, isFetching, refetch } = useWorkOrderDetail(id);

    if (id && isFetching && !workOrderData) {
        return (
            <Dialog open>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        );
    }

    return <NewWorkOrderV4 showLoader={showLoader} setShowLoader={setShowLoader} invoiceData={workOrderData || {}} fetchInvoceDetailData={refetch} />;
};

export default WorkOrderEdit;
